const initialstate = {
  newLocationType: false,
  type: '',
  id: '',
};

export default initialstate;
